import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(timezone)

const config = {
  CAN: {
    country: 'Canada',
    standard: [16, 22],
    express: [6, 12],
    reg: 'Canada|Halifax|Winnipeg|Toronto|Edmonton|St_Johns|Vancouver|Regina|Whitehorse',
    standardDays: <string[]>[],
    exppressDays: <string[]>[],
    shippingPrice: {
      standard: '12.99',
      express: '16.90',
    },
  },
  US: {
    country: 'United States',
    standard: [11, 19],
    express: [6, 12],
    reg: 'America',
    standardDays: <string[]>[],
    exppressDays: <string[]>[],
    shippingPrice: {
      standard: '6.99',
      express: '16.90',
    },
  },
  UK: {
    country: 'United Kingdom',
    standard: [9, 15],
    express: [9, 13],
    reg: 'London',
    standardDays: <string[]>[],
    exppressDays: <string[]>[],
    shippingPrice: {
      standard: '6.99',
      express: '16.90',
    },
  },
  AUS: {
    country: 'Australia',
    standard: [15, 23],
    express: [9, 13],
    reg: 'Australia',
    standardDays: <string[]>[],
    exppressDays: <string[]>[],
    shippingPrice: {
      standard: '6.99',
      express: '16.90',
    },
  },
  GER: {
    country: 'Germany',
    standard: [11, 17],
    express: [9, 13],
    reg: 'Berlin',
    standardDays: <string[]>[],
    exppressDays: <string[]>[],
    shippingPrice: {
      standard: '6.99',
      express: '16.90',
    },
  },
  ITA: {
    country: 'Italy',
    standard: [10, 14],
    express: [8, 10],
    reg: 'Rome',
    standardDays: <string[]>[],
    exppressDays: <string[]>[],
    shippingPrice: {
      standard: '6.99',
      express: '16.90',
    },
  },
  ES: {
    country: 'Spain',
    standard: [8, 12],
    express: [8, 10],
    reg: 'Madrid|Canary',
    standardDays: <string[]>[],
    exppressDays: <string[]>[],
    shippingPrice: {
      standard: '6.99',
      express: '16.90',
    },
  },
  FR: {
    country: 'Franch',
    standard: [7, 11],
    express: [8, 10],
    reg: 'Paris',
    standardDays: <string[]>[],
    exppressDays: <string[]>[],
    shippingPrice: {
      standard: '6.99',
      express: '16.90',
    },
  },
  NL: {
    country: 'Netherlands',
    standard: [8, 12],
    express: [8, 10],
    reg: 'Amsterdam',
    standardDays: <string[]>[],
    exppressDays: <string[]>[],
    shippingPrice: {
      standard: '6.99',
      express: '16.90',
    },
  },
  IL: {
    country: 'Ireland',
    standard: [11, 16],
    express: [8, 10],
    reg: 'Dublin',
    standardDays: <string[]>[],
    exppressDays: <string[]>[],
    shippingPrice: {
      standard: '6.99',
      express: '16.90',
    },
  },
}
function formatDays(days = 0) {
  return dayjs().add(days, 'day').format('MM/DD/YYYY')
}
function getCountryTimeZone() {
  // console.log('dayjs.tz.guess()', dayjs.tz.guess())
  let timeZone: any = dayjs.tz.guess() || 'America/New_York'
  timeZone = timeZone.split('/')
  // console.log('tiemZone', timeZone)
  const configKey = Object.keys(config)
  let result = config.US
  for (let i = 0; i < configKey.length; i += 1) {
    const keys = config[configKey[i] as keyof typeof config] || ''
    if (keys.reg.includes(timeZone[0]) || keys.reg.includes(timeZone[1])) {
      result = keys
      break
    }
  }
  result.standardDays = [
    formatDays(result.standard[0]),
    formatDays(result.standard[1]),
  ]
  result.exppressDays = [
    formatDays(result.express[0]),
    formatDays(result.express[1]),
  ]
  return result
}

export default getCountryTimeZone
